@let claimForm = form();
@let caseTypeControl = globalCaseType();
@let claimIndex = index();
@let currencies = currencyOptions();
@let typeIdOptions = claimTypeOptions();
<form [formGroup]="claimForm">
  <div class="flex vcenter">
    <span class="data-row-title">
      {{ claimIndex + 1 }}. követelés
      @if (hasAiFilledIn(claimForm)) {
        <span
          class="ai-badge"
          title="AI által kitöltve"
        >
          AI
        </span>
      }
    </span>
    <button
      payee-button
      color="alert-red"
      (click)="remove()"
    >
      Követelés törlése
    </button>
  </div>

  @if (isSzamlazzhu) {
    @let szInvoiceOptions = szamlazzhuInvoiceOptions();
    <h2>Számlázz.hu-s számla</h2>
    <payee-form-field>
      <payee-autocomplete
        [options]="szInvoiceOptions"
        [displayWith]="szamlazzhuInvoiceDisplayWith"
        [formControl]="ref_id"
      ></payee-autocomplete>
    </payee-form-field>
    @if (ref_id.hasError("required")) {
      <mat-error>Mező kitöltése kötelező!</mat-error>
    }
  }

  @if (invoiceOcrLoading) {
    <mat-progress-spinner
      diameter="24"
      mode="indeterminate"
    ></mat-progress-spinner>
  }
  @if (files.length === 0 && !invoiceOcrLoading) {
    <payee-dropzone
      height="taller"
      title="Tölts fel bizonyítékot a követeléshez"
      description=""
      [multiple]="false"
      (dropped)="claimEvidencesDropped($event)"
    ></payee-dropzone>
    <mat-error>Legalább egy fájl feltöltése kötelező!</mat-error>
  }
  @for (fileForm of files.controls; track fileForm; let fileIndex = $index) {
    <div
      class="flex vcenter evidence-row"
      [class.error]="fileForm.invalid"
    >
      <div class="evidence-index">{{ fileIndex + 1 }}.</div>
      <div class="flex column grow1">
        <div
          class="evidence-specification"
          [class.ai-filled]="isAiFilled(fileForm.controls.invoice_number)"
        >
          @if ((fileForm.value.case_type || caseTypeControl.value) === CASE_TYPE.INVOICE) {
            <span>Számla sorszáma:</span>
          }
          @if ((fileForm.value.case_type || caseTypeControl.value) === CASE_TYPE.CONTRACT) {
            <span>A követelés beazonosításához szükséges adatok:</span>
          }
          @if ((fileForm.value.case_type || caseTypeControl.value) === CASE_TYPE.CONDOMINIUM) {
            <span>Ingatlan címe:</span>
          }
          <span>{{ fileForm.value.invoice_number || "Nincs kitöltve" }}</span>
          @if (isAiFilled(fileForm.controls.invoice_number)) {
            <span
              class="ai-badge"
              matTooltip="AI által kitöltve"
            >
              AI
            </span>
          }
        </div>
        <div
          class="evidence-specification"
          [class.ai-filled]="isAiFilled(fileForm.controls.invoice_date)"
        >
          @if ((fileForm.value.case_type || caseTypeControl.value) === CASE_TYPE.INVOICE) {
            <span>Számla kelte:</span>
          }
          @if ((fileForm.value.case_type || caseTypeControl.value) === CASE_TYPE.CONTRACT) {
            <span>Szerződés kelte:</span>
          }
          @if ((fileForm.value.case_type || caseTypeControl.value) === CASE_TYPE.CONDOMINIUM) {
            <span>Tartozás kezdete (az első tartozásos hónap első napja)</span>
          }
          @if (fileForm.value.invoice_date) {
            <span>{{ $any(fileForm.value.invoice_date) | date: "yyyy.MM.dd." }}</span>
          }
          @if (!fileForm.value.invoice_date) {
            <span>Nincs kitöltve</span>
          }
          @if (isAiFilled(fileForm.controls.invoice_date)) {
            <span
              class="ai-badge"
              matTooltip="AI által kitöltve"
            >
              AI
            </span>
          }
        </div>
        <div>
          <span>{{ fileForm.value.file_name }}</span>
          <button
            payee-mini-icon-button
            type="button"
            color="white"
            (click)="openClaimFile(fileForm)"
          >
            <payee-icon name="external-link-blue"></payee-icon>
          </button>
        </div>
      </div>
      <div class="flex column">
        <button
          payee-mini-icon-button
          type="button"
          color="white"
          (click)="editClaimFile(fileForm)"
        >
          <payee-icon name="edit-grey"></payee-icon>
        </button>
        <button
          payee-mini-icon-button
          type="button"
          color="white"
          (click)="removeEvidence(fileIndex)"
        >
          <payee-icon name="trash-red"></payee-icon>
        </button>
      </div>
    </div>
  }
  <payee-form-field
    width="wide"
    [aiFilled]="isAiFilled(due_date_at)"
  >
    <span payee-label>Fizetési határidő</span>
    <payee-datepicker
      [formControl]="$any(claimForm.get('due_date_at'))"
      [max]="max"
      [min]="minDate()"
    ></payee-datepicker>
  </payee-form-field>
  <div class="flex">
    <payee-form-field
      width="shorter"
      [aiFilled]="isAiFilled(remaining_amount)"
    >
      <input
        payee-input
        [formControl]="remaining_amount"
      />
      <span payee-label>Fennálló követelés</span>
      @if (remaining_amount.hasError("required")) {
        <span payee-error>Mező kitöltése kötelező!</span>
      }
    </payee-form-field>
    <payee-form-field
      width="shorter"
      [aiFilled]="isAiFilled(original_amount)"
    >
      <input
        payee-input
        [formControl]="original_amount"
      />
      <span payee-label>Eredeti követelés</span>
      @if (original_amount.hasError("required")) {
        <span payee-error>Mező kitöltése kötelező!</span>
      }
    </payee-form-field>
    <payee-dropdown
      style="margin-top: 24px"
      width="shorter"
      [class.ai-filled]="isAiFilled(currency_iso)"
      [options]="currencies"
      [formControl]="$any(claimForm.get('currency_iso'))"
    ></payee-dropdown>
  </div>
  <payee-form-field
    width="wide"
    [aiFilled]="isAiFilled(type_id)"
  >
    <span payee-label>Követelés típusa</span>
    <payee-autocomplete
      [options]="typeIdOptions"
      [formControl]="type_id"
      [displayWith]="claimTypeDisplayedWith"
    ></payee-autocomplete>
  </payee-form-field>
  @if (showClaimTypeSpecification()) {
    <payee-form-field width="wide">
      <input
        payee-input
        [formControl]="specification"
      />
      <span payee-label>Követelés típus részletezés</span>
    </payee-form-field>
  }

  @if (interest_claim.enabled) {
    <form [formGroup]="interest_claim">
      <h2>Szerződéses kamat</h2>
      <div class="flex">
        <payee-form-field width="shorter">
          <input
            payee-input
            [formControl]="interest_rate"
          />
          <span payee-label>Kamat mértéke</span>
        </payee-form-field>
        <payee-form-field width="shorter">
          <input
            payee-input
            [formControl]="interest_claim_remaining_amount"
          />
          <span payee-label>Fennálló kamat</span>
          @if (interest_claim_remaining_amount.hasError("required")) {
            <span payee-error>Mező kitöltése kötelező!</span>
          }
        </payee-form-field>
        <payee-form-field width="shorter">
          <input
            payee-input
            [formControl]="interest_claim_original_amount"
          />
          <span payee-label>Eredeti kamat</span>
          @if (interest_claim_original_amount.hasError("required")) {
            <span payee-error>Mező kitöltése kötelező!</span>
          }
        </payee-form-field>
      </div>
    </form>
  }
</form>
